import React from 'react';
import { IStudent, StudentAnswerProps } from '@/components/staffer/Grading/types';
import { formattedUpdatedAt } from '@/components/staffer/Grading/utils';
import TeacherCommentAndScore from '@/components/staffer/Grading/TeacherCommentAndScore';
import styles from '@/components/staffer/Grading/QuestionCards/questionCard.module.scss';
import StudentAnswerInformation from '@/components/staffer/Grading/QuestionCards/StudentAnswerInformation';
import {
  DrawingQuestionStudentAnswer,
  GridQuestionStudentAnswer,
  MultipleChoiceQuestionStudentAnswer,
  WritingQuestionStudentAnswer,
  FillInTheBlankQuestionStudentAnswer,
  ImageMultipleChoiceQuestionStudentAnswer,
  DragAndDropQuestionStudentAnswer,
} from '@/components/staffer/Grading/StudentAnswers/index';

const COMPONENT_MAP = {
  DragAndDropQuestion: DragAndDropQuestionStudentAnswer,
  DrawingQuestion: DrawingQuestionStudentAnswer,
  FillInTheBlankQuestion: FillInTheBlankQuestionStudentAnswer,
  GridQuestion: GridQuestionStudentAnswer,
  ImageMultipleChoiceQuestion: ImageMultipleChoiceQuestionStudentAnswer,
  MultipleChoiceQuestion: MultipleChoiceQuestionStudentAnswer,
  OpenEndedQuestion: WritingQuestionStudentAnswer,
  // SliderQuestion: SliderQuestionStudentAnswer,
};

interface StudentAnswerCardProps extends StudentAnswerProps {
  student: IStudent
}

export const StudentAnswerCard = ({ question, questionAnswer, student }: StudentAnswerCardProps) => {
  const Component = COMPONENT_MAP[question.type];
  if (!Component) return null;

  const studentName = [student.first_name, student.last_name].filter(Boolean).join(' ');

  return (
    <div className={styles.card}>
      <div className={`${styles.header} tw-flex tw-justify-between tw-items-center`}>
        <div className="tw-text-base">
          {studentName}
        </div>
        {questionAnswer && (
          <div className="tw-text-xs">
            {`Last updated on: ${formattedUpdatedAt(questionAnswer.answer_updated_at)}`}
          </div>
        )}
      </div>
      <div className={styles.bodyWrapper}>
        <>
          <StudentAnswerInformation updatedAt={questionAnswer?.answer_updated_at} />
          <div className={`${styles.studentResponse} ${questionAnswer ? styles.answered : styles.unanswered}`}>
            <Component
              question={question}
              questionAnswer={questionAnswer}
            />
          </div>
          <TeacherCommentAndScore
            question={question}
            questionAnswer={questionAnswer}
          />
        </>
      </div>
    </div>
  );
};

export default StudentAnswerCard;
